exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".main___2atLs {\n  width: 93.5%;\n  margin: 20px auto 0 auto;\n  background: #fafafa;\n  -webkit-box-shadow: 0 0 8px 0 rgba(51, 51, 51, 0.14);\n          box-shadow: 0 0 8px 0 rgba(51, 51, 51, 0.14);\n  border-radius: 6px;\n  border-radius: 6px;\n  padding: 10px 5% 5px 5%;\n}\n\n.fileName___3g4Ml {\n  font-family: STKaitiSC-Regular;\n  font-size: 14px;\n  color: #666666;\n  letter-spacing: 0;\n  text-align: justify;\n}\n\n.item___3aHLY {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  border-bottom: solid 1px #eeeeee;\n  padding-bottom: 10px;\n  margin: 10px 0 5px 0;\n}\n\n.right___2y4Nj {\n  color: #666666;\n  font-size: 12px;\n  font-family: STKaitiSC-Regular;\n}\n\n.title___2OOFV {\n  font-size: 20px;\n  color: #333333;\n  letter-spacing: 0;\n  text-align: justify;\n  margin-bottom: 18px;\n}\n\n.main___2atLs > .item___3aHLY:last-child {\n  border-bottom: none;\n}\n", ""]);

// exports
exports.locals = {
	"main": "main___2atLs",
	"fileName": "fileName___3g4Ml",
	"item": "item___3aHLY",
	"right": "right___2y4Nj",
	"title": "title___2OOFV"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/css/Download.css
// module id = 597
// module chunks = 2